module.exports = __webpack_public_path__ + "static/media/01C.de692878.png";